import styles from './UploadStatusView.module.scss';
import { FileIcon } from './FileIcon';
import { Progress } from './Progress';

export interface IUploadStatusViewProps {
  fileName: string;
  fileSize: number;
  fileType?: string;
  progress?: number;
  error?: boolean;
  onRemove?: (value: string) => void;
}

export const UploadStatusView = ({
  fileName,
  fileSize,
  fileType,
  progress,
  onRemove,
  error,
}: IUploadStatusViewProps) => {
  const onFileRemove = () => onRemove && onRemove(fileName);

  return (
    <div className={styles.DocumentItem}>
      <div className={styles.DocumentInfo}>
        <FileIcon fileName={fileName} fileType={fileType} />
        <div className={styles.InfoWrap}>
          <span className={styles.Name}>
            {fileName}&nbsp;
            <button type="button" className={styles.Remove} onClick={onFileRemove}>
              x
            </button>
          </span>
          <span className={styles.FileSize}>{fileSize}KB</span>
        </div>
      </div>
      {!error && (
        <div className={styles.DocumentStatus}>
          <div className={styles.ProgressBarWrap}>
            <Progress percent={progress} isProgressNumberVisible />
          </div>
        </div>
      )}
      <div className="shared-error-message">{error}</div>
    </div>
  );
};
